var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AbfragerKnowAWordInputRow_1;
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../components/actor/Actor_';
import './knowaword.css';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
let AbfragerKnowAWordInputRow = AbfragerKnowAWordInputRow_1 = class AbfragerKnowAWordInputRow extends React.PureComponent {
    static get structureTemplate() {
        return (React.createElement("div", { "data-aspect": "inner", style: { flex: '0 0 300px', display: 'flex', flexDirection: 'row', justifyContent: 'center' } },
            React.createElement("div", { "data-aspect": "prefix", className: "knowaword_prepost", style: { marginRight: 12 } }),
            React.createElement("div", { "data-aspect": "main", style: { flex: '0 0 auto' } },
                React.createElement("input", { type: "text", "data-aspect": "input", className: "knowaword_input" })),
            React.createElement("div", { "data-aspect": "postfix", className: "knowaword_prepost", style: { marginLeft: 12 } })));
    }
    render() {
        const { question } = this.props;
        return React.createElement(Actor_, { actor: question.wordTask, structureTemplate: AbfragerKnowAWordInputRow_1.structureTemplate });
    }
};
__decorate([
    memoize
], AbfragerKnowAWordInputRow, "structureTemplate", null);
AbfragerKnowAWordInputRow = AbfragerKnowAWordInputRow_1 = __decorate([
    observer
], AbfragerKnowAWordInputRow);
export { AbfragerKnowAWordInputRow };
